import { useQuery } from '@apollo/client';
import {
  GetTaxonomyMetadataDocument,
  type GetTaxonomyMetadataQuery,
} from '../../../graphql/query/taxonomy/GetTaxonomyMetadata.generated.tsx';
import { TAXONOMY_METADATA_CATEGORIES_WITH_DIRECT } from '../../../modules/taxonomy/constants.ts';

export const useDealPromptTaxonomyMetadataOptions = (skip?: boolean) => {
  const { data, loading, error } = useQuery<GetTaxonomyMetadataQuery>(GetTaxonomyMetadataDocument, {
    variables: {
      categories: [...TAXONOMY_METADATA_CATEGORIES_WITH_DIRECT],
    },
    skip,
  });

  return {
    metadata: data?.segment_aggregate?.nodes || [],
    loading,
    error,
  };
};
